<script lang="ts">
	//UI
	import { PopperIcon } from "@hitit/new_ui";
	import AddPaymentModal from "./AddPaymentModal.svelte";
	//Utils
	import { processingDate } from "@hitit/hub/src/v7/utils";
	import { getMessageByCode } from "@hitit/mbr/src/functions/transactionMessageMap";
	//Image
	import EditIcon from "@hitit/hub/src/assets/Icons/Edit.png";
	import DeleteIcon from "@hitit/hub/src/assets/Icons/Delete.png";
	//Types
	import type { PaymentTransactionData } from "@hitit/api";
	//Props
	export let transactionData: PaymentTransactionData;
	export let open = false;
	//Constants

	//Variables
	let paymentArr: any = [];
	let catArr: any = [];
	let catArr2: any = [];
	let addPaymentModal = false;
	let loading = false;
	let clickType = "";

	//Functions

	function splitArr() {
		const { catResponseDTO, mclientVersion, ...restTransactionData } = transactionData;
		paymentArr = Object.entries(restTransactionData);
		const convertDate = paymentArr.find(
			(v: [string, string]) => v[0] === "createdDate"
		);
		convertDate[1] = processingDate(convertDate[1]);
		catArr = [...Object.entries(transactionData.catResponseDTO || {}).slice(0, 12), ["mclientVersion", mclientVersion ?? ""]];
		catArr2 = Object.entries(transactionData.catResponseDTO || {}).slice(
			12
		);
	}

	function addPaymentModalHandler(type: string) {
		clickType = type;
		addPaymentModal = true;
		document.body.style.overflow = "hidden";
		document.body.style.touchAction = "none";
	}

	function addPaymentModalCloseHandler() {
		addPaymentModal = false;
		document.body.style.overflow = "unset";
		document.body.style.touchAction = "unset";
	}

	async function paymentDataHandler(data: PaymentTransactionData) {
		loading = true;

		try {
		} catch (e) {
			console.log(e);
		}
	}

	//Do

	$: splitArr();
	$: transactionData;
</script>

<div class="container" t-id="TransactionLogging">
	{#if addPaymentModal}
		<AddPaymentModal
			paymentTransactionDto={transactionData}
			addPaymentModalCloseHandler={addPaymentModalCloseHandler}
			selectedPaymentMethod={undefined}
			clickType={clickType}
			loading={loading}
			on:ADD_CARD_PAYMENT={(e) => paymentDataHandler(e.detail)}
		/>
	{/if}
	<div class="transaction" on:click={() => (open = !open)}>
		<div class="message-box">
			<div class="message-wrapper">
				<div class="icon">
					<PopperIcon
						fill={transactionData.catResponseDTO?.responseMessage1 ===
							"Success" ||
						transactionData.catResponseDTO?.responseMessage2 === "Success"
							? "#44e4ae"
							: "#f66d6c"}
					/>
				</div>
				<p>
					<span
						class:success={transactionData.catResponseDTO?.responseMessage1 ===
							"Success" ||
							transactionData.catResponseDTO?.responseMessage2 === "Success"}
						>{transactionData.catResponseDTO?.responseMessage1 ||
							transactionData.catResponseDTO?.responseMessage2 ||
							"No response Message"}
					</span>
					<span class="convert-code-text"
						>{transactionData.catResponseDTO?.responseMessage1?.includes(":")
							? (() => {
									const matches =
										transactionData.catResponseDTO.responseMessage1.match(
											/:(\d{4})/g
										);
									const lastCode = matches
										? matches.slice(-1)[0]?.slice(1)
										: null; // 마지막 match에서 ':' 제거
									return lastCode ? getMessageByCode(lastCode) : "";
							  })()
							: ""}</span
					>
					
				</p>
				<span class="payment-text mobile"
						>{transactionData.paymentTransactionType || ""}</span
					>
			</div>
			<div class="etc">
				<!-- 반응형 자리 없어서 일단 주석. createdDate는 여러군데에서 확인가능 -->
				<!-- <div class="text-group">
					<span
						>{processingDate(
							transactionData.createdDate,
							"yyyy년 MM월 DD일 HH시 mm분 ss초"
						)}</span
					>
				</div> -->
				<span class="payment-text pc"
					>{transactionData.paymentTransactionType || ""}</span
				>
				<!-- <div class="btn-group">
					<img
						class="edit-btn"
						src={EditIcon}
						alt="edit"
						on:click|stopPropagation={() =>
							addPaymentModalHandler("transactionEdit")}
					/>
					<img class="delete-btn" src={DeleteIcon} alt="delete" />
				</div> -->
			</div>
		</div>
	</div>
	{#if open}
		<div class="cat-wrapper" on:click|stopPropagation>
			<div class="column">
				{#each paymentArr as [key, value]}
					<div class="item-box">
						<span class="key">{key}</span>
						<span class="value">{value}</span>
						<div class="horizontal-var" />
					</div>
				{/each}
			</div>
			<div class="column">
				{#each catArr as [key, value]}
					<div class="item-box">
						<span class="key">{key}</span>
						<span class="value">{value}</span>
						<div class="horizontal-var" />
					</div>
				{/each}
			</div>
			<div class="column">
				{#each catArr2 as [key, value]}
					<div class="item-box">
						<span class="key">{key}</span>
						<span class="value">{value}</span>
						<div class="horizontal-var" />
					</div>
				{/each}
			</div>
		</div>
	{/if}
</div>

<style lang="scss">
	@import "../../../variables.scss";
	.container {
		display: flex;
		flex-direction: column;
		border: 1px solid #efe7ed;
		border-radius: 5px;
		padding: 0px 10px;
		font-weight: 500;

		.transaction {
			display: flex;
			align-items: center;
			height: 44px;
			.message-box {
				display: flex;
				width: 100%;
				.message-wrapper {
					display: flex;
					flex-direction: column;
					align-items: flex-start;
					min-width: 195px;
					width: 100%;

					p {
							width: 100%;
							overflow: hidden;
							text-overflow: ellipsis;
							white-space: nowrap;
						}
					.icon {
						display: none;
					}
					span {
						@include appleAdjustTextForSize(16);
						color: #e54848;

						&.success {
							@include appleAdjustTextForSize(16);
							color: #10c181;
						}
					}
					.payment-text {
						@include appleAdjustTextForSize(14);
						font-weight: 200;
						color: #6d6f76;
					}
				}

				.etc {
					@include appleAdjustTextForSize(14);
					color: #46474b;
					display: flex;
					flex-direction: column;
					justify-content: center;
					margin-left: auto;
					/* width: 100%; */
					.payment-text {
						&.pc {
							display: none;
						}
					}
					.text-group {
						display: flex;
						justify-content: space-between;
						width: 110%;
						order: 1;
						span {
							font-weight: 200;
							color: #6d6f76;
						}
					}
					.btn-group {
						display: flex;
						gap: 10px;
						order: 0;
						justify-content: flex-end;
						img {
							width: 20px;
							height: 20px;
						}
					}
				}
			}

			&:hover {
				cursor: pointer;
			}
		}
		.cat-wrapper {
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			cursor: auto;
			.column {
				display: flex;
				flex-direction: column;
				max-width: 470px;
				width: 100%;
				gap: 10px;
				.item-box {
					display: flex;
					flex-direction: column;
					width: 100%;
					height: auto;
					max-height: 106px;
					gap: 5px;
					.key {
						@include appleAdjustTextForSize(14);
						font-weight: 200;
						color: #6d6f76;
					}
					.value {
						@include appleAdjustTextForSize(16);
						font-weight: 200;
						color: #46474b;
					}
					.horizontal-var {
						width: 95%;
						height: 1px;
						background-color: #e6e7ec;
					}
				}

				:last-child {
					.horizontal-var {
						display: none;
					}
				}
			}
		}
	}

	@include DesktopSize {
		.container {
			font-size: 1.25rem;

			.transaction {
				.message-box {
					.message-wrapper {
						flex-direction: row;
						align-items: center;
						gap: 10px;
						min-width: 195px;

						p {
							overflow: hidden;
							text-overflow: ellipsis;
							white-space: nowrap;
						}
						.icon {
							display: block;
							min-width: 20px;
							height: 20px;
						}
						span {
							@include appleAdjustTextForSize(16, false);
							@include heightRelativeToFontSize(20);
						}

						.payment-text {
							&.mobile {
								display: none;
							}
						}
					}

					.etc {
						@include appleAdjustTextForSize(14, false);
						flex-direction: row;
						gap: 40px;
						max-width: 455px;
						justify-items: unset;

						.payment-text {
							@include appleAdjustTextForSize(16, false);
							line-height: unset;
							font-weight: 200;
							color: #6d6f76;

							&.pc {
								display: block;
							}
						}

						.text-group {
							width: 100%;
							max-width: 330px;
							order: unset;
						}
						.btn-group {
							gap: 20px;
							order: unset;
							img {
								width: 26px;
								height: 26px;
							}
						}
					}
				}

				&:hover {
					cursor: pointer;
				}
			}
			.cat-wrapper {
				flex-direction: row;
				.column {
					.item-box {
						gap: 10px;
						.key {
							@include appleAdjustTextForSize(14, false);
							min-height: 25px;
						}
						.value {
							@include appleAdjustTextForSize(16, false);
							min-height: 30px;
						}
					}
				}
			}
		}
	}
</style>
